import { render, staticRenderFns } from "./ArticleListingDrenushaXharra.vue?vue&type=template&id=4105f09c&scoped=true"
import script from "./ArticleListingDrenushaXharra.vue?vue&type=script&lang=js"
export * from "./ArticleListingDrenushaXharra.vue?vue&type=script&lang=js"
import style0 from "./ArticleListingDrenushaXharra.vue?vue&type=style&index=0&id=4105f09c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4105f09c",
  null
  
)

export default component.exports